module.exports = __webpack_public_path__ + "img/h1-video.fe1e9d2e.jpg";